import './Header.css'
import {AnimatedToBigger} from "../../components/animated/Animated-to-bigger";
const man = require('./images/man.png')
const background = require('./images/background.png')
function Header() {
    return (
        <section className='header'>
            <div className='header__left-side'>
                <h1 className='header__left-side__title'>All dreams <span>must</span> be fulfilled.</h1>
                <button className='header__left-side__button'>Let's work!</button>
            </div>

            <div className='header__right-side' style={{
                backgroundImage: `url(${background})`,
                backgroundPosition: 'right',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: '0'
            }}>
                <AnimatedToBigger>
                    <img src={man} alt='' className='header__right-side__image'/>
                </AnimatedToBigger>
            </div>
        </section>
    )
}

export default Header